import { theme } from "../../theme/css/theme.css";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

import { zIndexes } from "../../theme";

export const poiContainerStyle = style({
  width: 0,
  height: 0,
  position: "absolute",
  zIndex: zIndexes.mapPOI,
});

export const poiStyle = recipe({
  base: {
    width: rem(48),
    height: rem(48),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    position: "absolute",
    bottom: 0,
    backgroundColor: theme.colors.background,
    borderRadius: theme.borderRadiuses.s,
  },
  variants: {
    hoverable: {
      true: {
        pointerEvents: "auto",
        cursor: "pointer",
        selectors: {
          "&:hover": {
            zIndex: zIndexes.mapMainMarker,
            backgroundColor: theme.colors.primary,
            color: theme.colors.onPrimary,
          },
        },
      },
    },
    active: {
      true: {
        backgroundColor: theme.colors.primary,
        color: theme.colors.onPrimary,
        pointerEvents: "none",
      },
    },
  },
});

export const poiContentStyle = style({
  alignItems: "flex-start",
});

export const poiCardStyle = recipe({
  base: {
    width: rem(252),
    position: "absolute",
    bottom: `calc(100% + ${theme.spacings.m})`,
    left: "50%",
    transform: "translateX(-50%)",
    pointerEvents: "auto",
  },
  variants: {
    closable: {
      true: {
        width: rem(300),
      },
    },
  },
});

export const poiCloseStyle = style({
  alignSelf: "flex-start",
});

export const poiTitleStyle = style({
  lineHeight: 1.2,
});
